import React from 'react';
import * as u from './utils.js'

import AppSettingsContext from './context.js';
import DefaultTemplate from './templates/default.js';
import SimpleTemplate from './templates/simple.js';
import DefaultBubbleTemplate from './templates/default_bubble.js';
import SimpleBubbleTemplate from './templates/simple_bubble.js';
import SideImageTemplate from './templates/side_image.js';
import SideImageBubbleTemplate from './templates/side_image_bubble.js';
import CardTemplate from './templates/card.js';
import QuoteTemplate from './templates/quote.js';

/*---------------------------------------------*/

export default class Testimonial extends React.Component {
	static contextType = AppSettingsContext;

	constructor() {
		super();
		this.container = React.createRef();
	}

	render() {
		let templateId = this.context.get('template.id','default');
		let partialDisplay = !!this.props.part;
		let spacing = this.context.get('layout.spacing',24);

		let backgroundColor = u.renderColor(this.context.get('style.bg.testimonial'));
		let borderRadius = this.context.get('style.testimonial.border.radius',0);
		let borderWidth = this.context.get('style.testimonial.border.width',0);
		let borderColor = u.renderColor(this.context.get('style.testimonial.border.color'));
		
		let styles = {
			container: {
				...this.props.baseStyle
			}
		}

		if (!this.props.part) {
			styles.container = {
				...styles.container,
				padding: ('padding' in styles.container) ? styles.container.padding : (spacing / 2),
				display: 'inline-block',
				boxSizing: 'border-box',
				verticalAlign: 'top',
				minWidth: this.context.DEFS.templates[templateId].minWidth,
				overflow: 'hidden'
			};

			styles.testimonial = {
				boxSizing: 'border-box',
				whiteSpace: 'normal',
				fontFamily: '"Roboto", sans-serif',
				background: backgroundColor,
				zIndex: 0,
				overflow: 'hidden',
				borderWidth: borderWidth,
				borderStyle: 'solid',
				borderRadius: borderRadius,
				borderColor: borderColor
			}
		}

		let templates = {
			'default': DefaultTemplate,
			'default_bubble': DefaultBubbleTemplate,
			'simple': SimpleTemplate,
			'simple_bubble': SimpleBubbleTemplate,
			'card': CardTemplate,
			'quote': QuoteTemplate,
			'side_image': SideImageTemplate,
			'side_image_bubble': SideImageBubbleTemplate
		}

		const TemplateTag = templates[templateId];
		let content = null;
		if (!TemplateTag) {
			content = <div style={styles.testimonial}>Template {templateId} not found</div>;
			
		} else {
			let width = this.container && this.container.current && (this.container.current.offsetWidth - spacing);
			if (width || partialDisplay) {
				content = <TemplateTag {...this.props} width={width} baseStyle={styles.testimonial} />;

			} else {
				// if the container was not rendered yet - we can't determine its width.
				// let's then generate an empty testimonials now, then render it again, with width available
				setTimeout(() => this.forceUpdate());
			}
		}

		if (partialDisplay)
			return content;

		let hasContainer = this.context.get('template.container',true);
		if (!hasContainer) {
			delete styles.testimonial.background;
			delete styles.testimonial.borderWidth;
			delete styles.testimonial.borderStyle;
			delete styles.testimonial.borderRadius;
			delete styles.testimonial.borderColor;
		}


		return (
			<div className="testimonial-container align-container" style={styles.container} ref={this.container}>
				{content}
			</div>
		)
	}
}

/*---------------------------------------------*/
